import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(/images/home-hero-askari-security-services.jpg)",
        }}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="animate-fade-in-up opacity-0">
            <span className="inline-block text-accent-400 text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-6">
              California&apos;s Trusted Security Partner
            </span>
          </div>

          <h1 className="animate-fade-in-up animation-delay-200 opacity-0 font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.1] mb-6">
            Askari Security Services
            <br />
            <span className="italic font-serif font-normal text-accent-400">
              &amp; Risk Management
            </span>
          </h1>

          <p className="animate-fade-in-up animation-delay-400 opacity-0 text-base md:text-lg lg:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Professional protection services for businesses, communities, and
            individuals across all of California. Licensed, bonded, and veteran-owned.
          </p>

          <div className="animate-fade-in-up animation-delay-600 opacity-0 flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-sm md:text-base"
            >
              Request a Quote
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 border border-background-50/40 hover:border-background-50 text-background-50 font-medium px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-sm md:text-base"
            >
              Explore Services
              <i className="ri-arrow-down-line" />
            </Link>
          </div>

          <div className="animate-fade-in-up animation-delay-800 opacity-0 flex flex-col sm:flex-row items-center justify-center gap-6 text-background-50/70 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-accent-400" />
              <span className="font-medium">24/7 Emergency: (562) 606-0053</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-background-50/30" />
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-400" />
              <span className="font-medium">CA PPO #17831</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-background-50/60 rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
}